import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";

import CheckboxGroup from "components/InputsField/formikInputs/CheckboxGroup";
import { TransportDropdownService } from "service/dropdownServices/TransportDropdown";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import FormikRadioField from "components/InputsField/formikInputs/FormikRadioField";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import Title from "components/common/Layout/Title";
import FormRow from "components/common/Layout/FormRow";

import styles from "./styles.module.scss";
import { UTILS } from "endpointsConst";

const BODY_TYPE_TRAILER = 3;

const TransportBody = () => {
    const [bodyAdditionalOptions, setBodyAdditionalOptions] = useState([]);
    const lang = useSelector((state) => state.settings.lang);
    const { t } = useTranslation();
    const { values } = useFormikContext();

    const loadAdditionalBodyTypes = useCallback(() => {
        TransportDropdownService.getBodyTypesAdditional(lang)
            .then((res) => {
                let bodyAdditionalOptions = res.data.map((el) => {
                    return {
                        label: el.value,
                        value: el.id,
                    };
                });
                setBodyAdditionalOptions(bodyAdditionalOptions);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, [lang]);

    useEffect(() => {
        loadAdditionalBodyTypes();
    }, [loadAdditionalBodyTypes]);

    return (
        <>
            <Title withMargin>{t("transportFields.body_section.heading")}</Title>
            <FormRow>
                <>
                    <AsyncSelect
                        name="transport_bodytype_ids"
                        label={t("transportFields.body_section.body")}
                        url={`${UTILS}/transport-bodytypes/?lang=${lang}`}
                        required
                        placeholder={t("transportFields.choose_list_grey")}
                        sort
                        isMulti
                    />
                    <div className={styles.checkboxes}>
                        {bodyAdditionalOptions.length > 0 && (
                            <CheckboxGroup
                                checkboxes={bodyAdditionalOptions.map((el, index) => (
                                    <FormikRadioField
                                        key={index}
                                        id={`transport_bodytype_additionals_id[${index}]`}
                                        name="transport_bodytype_additionals_id"
                                        label={el.label}
                                        value={String(el.value)}
                                        isUnClickable
                                    />
                                ))}
                            />
                        )}
                    </div>
                </>
                <>
                    <AsyncSelect
                        name="transports_loading_types"
                        label={t("transportFields.body_section.uploading")}
                        url={`${UTILS}/loadingTypes/?lang=${lang}`}
                        placeholder={t("transportFields.choose_list_grey")}
                        isMulti
                    />
                    <div className={styles.checkboxes}>
                        <CheckboxGroup
                            checkboxes={[
                                <FormikCheckboxField
                                    name="conics"
                                    id="conics"
                                    label={t("transportFields.body_section.bolsters")}
                                />,
                                <FormikCheckboxField
                                    name="gidrolift"
                                    id="gidrolift"
                                    label={t("transportFields.body_section.tailLift")}
                                />,
                            ]}
                        />
                    </div>
                </>
            </FormRow>
            {Number(values.transport_bodytype_additionals_id) === BODY_TYPE_TRAILER && (
                <FormRow withMargin>
                    <FormRow withSpace>
                        <FormikTextField
                            name="trailer_registration_number"
                            label={t("transportFields.body_section.if_checkbox_3.licence")}
                            maxLength="13"
                            placeholder="A 007AA 183"
                        />
                        <></>
                    </FormRow>
                    <></>
                </FormRow>
            )}
        </>
    );
};

export default TransportBody;
